import callIfArgumentsPass from "../../../utils/callIfArgumentsPass";
import curry from "../../../lib/core/functional/curry";
import renderView from "./module";
import { getUserTransport, getSiteId } from "../_common";

function didTitleChanged(oldProfileSite, profileSite) {
    return profileSite.title !== oldProfileSite.title;
}

export const renderEditTitle = curry(function renderEditTitle(
    renderWithProps,
    userTransport,
    profileSite
) {
    function saveSiteTitle(title) {
        userTransport.sendChanges({ title });
    }

    return renderWithProps({ saveSiteTitle, title: profileSite.title });
});

const onTransport = curry(function onTransport(element, userTransport) {
    userTransport.subscribeToChanges(
        callIfArgumentsPass(didTitleChanged, renderEditTitle(renderView(element), userTransport))
    );
});

export default function renderer(context, element) {
    const siteId = getSiteId(context, element);
    if (!siteId) {
        return;
    }

    getUserTransport(context, siteId).then(onTransport(element)).catch(console.error);
}
